import { render, staticRenderFns } from "./RefundPolicy.vue?vue&type=template&id=415c5b4b&scoped=true&"
import script from "./RefundPolicy.vue?vue&type=script&lang=js&"
export * from "./RefundPolicy.vue?vue&type=script&lang=js&"
import style0 from "./RefundPolicy.vue?vue&type=style&index=0&id=415c5b4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c5b4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
